// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

export const getPersonChecksList = createAsyncThunk('appPersonChecksList/getPersonChecksList', async params => {
   params.page = params.page === 0 ? 0 : params.page - 1
   const response = await axios.post(`https://api.mfauto.com.ua/company/kyc/person-check/all?env=${process.env.REACT_APP_NODE_ENV}`, {
      token: localStorage.getItem('token'),
      page: params.page,
      rows: params.rows,
      code: params.code || undefined,
      full_name: params.full_name || undefined
   })
   return {
      params,
      data: response.data.checks,
      totalPages: response.data.total_elements
   }
})

export const appPersonChecksListSlice = createSlice({
   name: 'appPersonChecksList',
   initialState: {
      data: [],
      total: 1,
      params: {}
   },
   reducers: {},
   extraReducers: builder => {
      builder
      .addCase(getPersonChecksList.fulfilled, (state, action) => {
         state.data = action.payload.data
         state.params = action.payload.params
         state.total = action.payload.totalPages
      })
   }
})

export default appPersonChecksListSlice.reducer
